import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export class CardExamsEstablishmentInformationApi extends ComponentAPI {
}
//# sourceMappingURL=card-exam-establishment-information-api.js.map